var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Animation',{attrs:{"name":"fade"}},[(_vm.open)?_c('div',{class:['root', {'show-loader': _vm.loading}]},[_vm._t("default"),_c('div',{staticClass:"showLoader loader"})],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }